import React from "react";
import ReactDOM from "react-dom/client";
import CognitoryAppRouter from "./cognitoryAppRouter";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <CognitoryAppRouter />
  </React.StrictMode>,
);
